import { createContext } from 'react';

/**
 * Which public URL the new form is running on, and which variant of it.
 *
 * The new form is served through internal routes (/demo-form-next/...) that the middleware rewrites the public URLs to.
 * It must push / redirect using the PUBLIC path the visitor is on (/mortgage-lead-generation-demo or /pricing), never the
 * internal one, and the /pricing route runs the form in its pricing mode without a ?source=pricing query. Each route file
 * provides the right value; the default is the original demo path.
 */
export type DemoBase = { path: string; source: string };
export const DemoBaseContext = createContext<DemoBase>({ path: '/mortgage-lead-generation-demo', source: 'default' });
